// Centralized session storage utility for per-tab authentication isolation.
// Using sessionStorage ensures that opening multiple tabs allows logging into different accounts
// (e.g. Lawyer in Tab 1, Customer in Tab 2, Admin in Tab 3),
// and closing the tab automatically logs out that account.

export const getAuthToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

export const setAuthToken = (token) => {
  if (token) {
    sessionStorage.setItem("token", token);
    localStorage.removeItem("token"); // Prevent cross-tab override
  } else {
    sessionStorage.removeItem("token");
    localStorage.removeItem("token");
  }
};

export const getAuthUser = () => {
  try {
    const raw =
      sessionStorage.getItem("user") ||
      sessionStorage.getItem("legalagent_user") ||
      localStorage.getItem("user") ||
      localStorage.getItem("legalagent_user");
    if (raw) return JSON.parse(raw);
  } catch (e) {
    console.error("Error parsing stored user:", e);
  }
  return null;
};

export const setAuthUser = (user) => {
  if (user) {
    const serialized = typeof user === "string" ? user : JSON.stringify(user);
    sessionStorage.setItem("user", serialized);
    sessionStorage.setItem("legalagent_user", serialized);
    // Clear localStorage to isolate to this tab only
    localStorage.removeItem("user");
    localStorage.removeItem("legalagent_user");
  } else {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("legalagent_user");
    localStorage.removeItem("user");
    localStorage.removeItem("legalagent_user");
  }
};

export const clearAuthSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("legalagent_user");
  sessionStorage.removeItem("admin_session");
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("legalagent_user");
};
